<template src="./index.html"></template>

<script>
import { getAssociatedUserInfo } from '../../../../../../api/home.js';
import { getdata } from './data.js';
export default {
	props: {
		id: {
			type: String,
			default: ''
		},
		activeName: {
			type: String,
			default: ''
		},
		Memberk: {
			type: Boolean,
			default: false
		}
	},
	data() {
		return {
			headData: getdata().headData,
			tableData: [{}],
			tablekey: 0,
			likeSearch: ''
		};
	},
	watch: {
		id: function(indexVal, oldVal) {
			if (indexVal != '') {
				this.searrchForData();
			}
		},
		Memberk: function(indexVal, oldVal) {
			this.searrchForData();
		}
	},
	created() {
		this.searrchForData();
	},
	mounted() {},
	methods: {
		sskcx() {
			this.searrchForData();
		},
		searrchForData() {
			if (this.activeName == '1') {
				let params = { roleId: this.id, criteriaJson: '{"likeSearch":"'+this.likeSearch+'"}'};
				getAssociatedUserInfo(params).then(res => {
					if (res.data.code == '200') {
						this.tableData = res.data.data;
					}
				});
			}
		}
	}
};
</script>

<style scoped lang="less">
@import url('./index.less');
</style>
